import { render, staticRenderFns } from "./UserReview.vue?vue&type=template&id=4e171ff2&"
import script from "./UserReview.vue?vue&type=script&lang=js&"
export * from "./UserReview.vue?vue&type=script&lang=js&"
import style0 from "./UserReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports